import { lazyNamed } from 'src/utils/lazyNamed';
import CompanyDetails from './containers/CompanyDetails';
import { CompanyDetailsTab } from './containers/CompanyDetails/types';
import { CompanyFormSearchKey } from './containers/CompanyForm/types';

export { CompanyFormSearchKey, CompanyDetailsTab };

export default {
  CompaniesList: lazyNamed(() => import('./containers/CompaniesList'), 'CompaniesList'),
  CompanyForm: lazyNamed(() => import('./containers/CompanyForm'), 'CompanyForm'),
  CompanyDetails,
};
